export enum WidthPercentage {
  TWENTY_FIVE = 'w25',
  FORTY = 'w40',
  FIFTY = 'w50',
  SIXTY = 'w60',
  HUNDRED = 'w100',
}
